import { Component } from "@angular/core";
import { FieldType } from "@kre-form/core";
import * as _ from "lodash";
@Component({
  selector: "kreform-field-ion-number",
  template: `
    <ng-container *ngIf="!!editor; else other">
      <ion-input
        type="input"
        ionKreFormFloat
        [decimalNumber]="to.precision"
        [ionKreFormAttributes]="field"
        [max]="to.max || 999999"
        [min]="to.min || -999999"
        [(ngModel)]="value"
        (ngModelChange)="changeValue($event)"
        (ionBlur)="inputBlur($event)"
      ></ion-input>
    </ng-container>
    <ng-template #other>
      <div class="fieldtext">{{ number }}</div>
    </ng-template>
  `,
})
export class KreFormFieldIonNumber extends FieldType {
  _value: any;
  public get value(): any {
    if (
      this.model &&
      this.model[this.key] !== undefined &&
      this.model[this.key] !== null &&
      this.model[this.key] !== ""
    ) {
      return this.model[this.key];
    }
    return null;
  }
  public set value(value: any) {
    this._value = value;
  }
  changeValue(value) {
    this.model[this.key] = value;
  }

  inputBlur(e: any) {
    if (e.target && e.target.value && this.model) {
      let value = e.target.value;
      this.model[this.key] = value;
      this.formControl.patchValue(value);
      this.formControl.markAsTouched();
    } else {
      if (e.target.value == null || e.target.value == "") {
        if (this.model[this.key] != undefined && this.model[this.key] != null) {
          this.model[this.key] = null;
        }
      }
      this.formControl.patchValue(null);
      this.formControl.markAsTouched();
    }
  }
  get number() {
    let result = this.text;
    if (
      this.to != undefined &&
      this.to != null &&
      this.to["precision"] != undefined &&
      this.to["precision"] != null
    ) {
      if (!!result || result === 0) {
        result = _.round(result, this.to["precision"]);
        if (
          !_.isEmpty(this.model) &&
          (this.model as Object).hasOwnProperty(this.key)
        ) {
          this.model[this.key] = result;
        }
      }
    }
    return result;
  }
}
